import { STORE_SERVICE_DETAIL } from "actions"

export const initialState = {
  id: "",
  serviceId: "",
  name: "",
  nameEn: "",
  toses: [],
}

export const service = (state = initialState, action) => {
  switch (action.type) {
    case STORE_SERVICE_DETAIL:
      return { ...action.payload }
    default:
      return state
  }
}

export default service
